export default __webpack_public_path__ + "static/media/Screenshot_4.8a0e0519.png";